import { render } from "./TestingGroup.vue?vue&type=template&id=09c38da8"
import script from "./TestingGroup.vue?vue&type=script&lang=js"
export * from "./TestingGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__